import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSites } from 'app/mocks/data/park/sites'

import { formDataToData } from 'app/utils/app/requests'
import { api } from 'app/utils/constants'

import {
    Microwave,
    MicrowavePayload,
    PositionMicrowave,
} from 'app/types/machines/microwave'

export const createMicrowave = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.microwaves.LIST}`,
    async ({ request }) => {
        const data = await request.formData()

        const payload = formDataToData(data)
        const payloadParsed = MicrowavePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Microwave>(
            {
                id: 999,
                ...payloadParsed.data,
                site: allSites.find(
                    (site) => site.id === payloadParsed.data.site,
                ),
                microwave_units: payloadParsed.data.microwave_units.map(
                    (unit) => ({
                        ...unit,
                        id: 999,
                        position: PositionMicrowave.parse(unit.position),
                        purchase_invoice:
                            'https://localhost:3000/microwaves/999/purchase-invoice',
                        is_enabled: false,
                        model: 'Microwave Model 123',
                        power: 123,
                    }),
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
